import { getPropositions } from '@/api/reseaux/index';
import moment from 'moment';

export default async function getDispoReseauxTempo(listeReseaux, dateVisu, dateFin) {
  const debut = moment(dateVisu, 'YYYYMMDD');
  const listNumReseaux = listeReseaux.map(reseau => reseau.num);
  const result = await getPropositions(debut.day(1).format('YYYYMMDD'), dateFin.format('YYYYMMDD'), listNumReseaux);
  for (const reseau of listeReseaux) {
    if (Object.keys(result.data).includes(reseau.num.toString())) {
      const key = debut.isoWeekYear() + debut.isoWeek().toString().padStart(2, '0');
      const dataProp = result.data[reseau.num][key];
      /* eslint-disable no-continue */
      if (dataProp === undefined) continue;
      const reste = dataProp.facesPrevues - dataProp.quantiteVendue;
      reseau.nbrFacesRestantes = reste > 0 ? reste : 0;
      reseau.nbrFacesTotal = dataProp.facesPrevues;

      if (!dataProp.estVendu) {
        reseau.dispo = 'dispo';
        reseau.dispoClass = 'is-success';
      } else if (dataProp.estVendu && dataProp.quantiteVendue >= dataProp.facesPrevues) {
        reseau.dispo = 'indispo';
        reseau.dispoClass = 'is-danger';
      } else {
        reseau.dispo = 'partiellementDispo';
        reseau.dispoClass = 'is-warning';
      }
    } else {
      reseau.dispo = 'indispo';
      reseau.nbrFacesRestantes = 0;
      reseau.nbrFacesTotal = 0;
    }
  }
  return { listeReseaux, result };
}




// WEBPACK FOOTER //
// ./src/services/general/dispoReseauxTempo.js